module.exports = __webpack_public_path__ + "img/icon_s2examinationvideo.4c5f9652.png";